import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const navLinks = [
  { label: "首页", href: "#hero" },
  { label: "服务", href: "#services" },
  { label: "案例", href: "#projects" },
  { label: "关于", href: "#about" },
  { label: "评价", href: "#testimonials" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="flex items-center justify-between px-6 md:px-12 h-16 md:h-18">
        <a href="#hero" className="flex items-center gap-2 cursor-pointer">
          <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-primary-500">
            <span className="text-background-50 font-heading font-bold text-base md:text-lg">天</span>
          </div>
          <span
            className={`font-heading font-bold text-lg md:text-xl tracking-tight ${
              scrolled ? "text-foreground-900" : "text-white"
            }`}
          >
            Tianyi
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600"
                  : "text-white/85 hover:text-white"
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#cta"
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
              scrolled ? "text-foreground-700 hover:text-primary-600" : "text-white/85 hover:text-white"
            }`}
          >
            登录
          </a>
          <a
            href="#cta"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            免费咨询
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-sm"></i>
            </span>
          </a>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer ${
            scrolled ? "text-foreground-800" : "text-white"
          }`}
        >
          <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="flex flex-col px-6 py-4 gap-3">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="text-foreground-700 hover:text-primary-600 text-sm font-medium py-2 transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#cta"
              onClick={() => setMobileOpen(false)}
              className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all mt-2"
            >
              免费咨询
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}